import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const timestamp = parseInt(this.element.dataset.time, 10);
    const date = new Date(timestamp);

    this.element.textContent = date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
}